<template>
	<div class="view-media-wrap">
		<template v-if="type==1">
			<el-dialog
			  	:visible.sync="showViewPicture"
				:width="isFullView?'100%':'650px'"
				center
				:fullscreen="isFullView"
				:before-close="closePic">
				<div>
					<p class="abs view-tool-wrap"><i class="iconfont" :class="isFullView?'icon-quxiaoquanping1':'icon-max-screen'" :title="isFullView?'取消全屏':'全屏'" @click="fullView"></i></p>
					<div>
						<el-carousel :arrow="imglist.length>1?'always':'never'" :height="viewPicHeight" :autoplay="autoplay" :initial-index="index" ref="carousel">
						    <el-carousel-item v-for="(item,index) in imglist" :key="index" class="el-carousel-img-wrap">
						      	<img :src="item.url" width="100%">
						    </el-carousel-item>
					  	</el-carousel>
					</div>
				</div>
			</el-dialog>
		</template>
		<template v-if="type==2">
			<el-dialog
				:before-close="initVideo"
			  	:visible.sync="showViewVideo"
				width="650px"
				center>
				<div class="rela com-view-video-wrap">
					<video :src="url" :poster="poster" width="100%" height="100%" controls id="currentVideo"></video>
				</div>
			</el-dialog>
		</template>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				showViewPicture:false,
				showViewVideo:false,
				isFullView:false,
				viewPicHeight:'600px',
			}
		},
		props:{
			//预览类型，1为图片，2为视频。默认为图片
			type:{
				type:Number,
				default(){
					return 1
				}
			},
			//图片列表
			imglist:{
				type: Array,
			    default(){
			        return []
			    }
			},
			//图片当前索引
			index:{
				type:Number,
				default(){
					return 0
				}
			},
			//是否自动播放
			autoplay:{
				type:Boolean,
				default(){
					return false
				}
			},
			//视频url
			url:{
				type: String,
			    default(){
			        return ''
			    }
			},
			//视频海报
			poster:{
				type: String,
			    default(){
			        return ''
			    }
			}
		},
		methods:{
			//关闭对话框后初始化视频
			initVideo(){
				let media = document.getElementById('currentVideo')
				media.load()
				this.showViewVideo = false
			},
			//全屏预览
			fullView(){
				this.isFullView = !this.isFullView
				this.viewPicHeight = this.isFullView?document.body.clientHeight-85+'px':'600px'
			},
			//关闭对话框后初始化图片
			closePic(){
				this.showViewPicture = false
				this.isFullView = false
				this.viewPicHeight = '600px'
			}
		},
		watch:{
			index(val){
				if(this.type == 1){
					//刚打开dialog组件时，carousel组件还未生成，此时获取不到ref，因此采取延时方法
					setTimeout(()=>{
						this.$refs.carousel.setActiveItem(val)
					},500)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.view-media-wrap{
		.view-tool-wrap{
			right:50px;
			top:17px;
			i{
				font-size:13px;
				color:#909399;
				cursor:pointer;
				&:hover{
					color:#409EFF;
				}
			}
		}
		.el-carousel-img-wrap{
			height:100%;
			overflow-y:scroll;
		}
	}
	.com-view-video-wrap{
		width:600px;
		height:337.5px;
		video{
			object-fit: fill;
		}
	}
</style>